/*
 * Who holds each side (the state's `players`: signed-in commanders' Discord
 * names and avatars). Sides nobody signed in holds keep their faction's
 * name.
 */

import { createSignal } from "solid-js";

export interface Player {
  side: number;
  name: string;
  avatar: string;
}

const [players, setPlayersSignal] = createSignal<Player[]>([]);
export { players };

/** Faction names to fall back on (the header's). */
let factionNames: string[] = [];
export function setFactionNames(names: string[]): void {
  factionNames = names;
}

export function setPlayers(state: Record<string, unknown>): void {
  const list = state.players as Player[] | undefined;
  if (!list) return;
  const now = players();
  if (now.length === list.length && now.every((p, i) => p.side === list[i].side && p.name === list[i].name && p.avatar === list[i].avatar)) return;
  setPlayersSignal(list);
}

/** A side's name: its commander's, else its faction's. */
export function sideName(side: number): string {
  return players().find((p) => p.side === side)?.name ?? factionNames[side] ?? `Side ${side + 1}`;
}

/** A side's commander's avatar, if one's signed in. */
export function sideAvatar(side: number): string | null {
  return players().find((p) => p.side === side)?.avatar ?? null;
}

/** An avatar as inline HTML (for the readouts built as strings). */
export function avatarHtml(side: number, size = 14): string {
  const a = sideAvatar(side);
  return a ? `<img class="avatar" src="${a.replace(/"/g, "")}" alt="" width="${size}" height="${size}"> ` : "";
}
